import { Component, Inject, OnInit } from '@angular/core';
import { TrackerService } from '@shared/services/tracker.service';
import frenchi18n from '@assets/i18n/fr.json';
import type { BrowserBroadcast } from '@adapters/broadcast/browserBroadcast';
import { browserBroadcastToken } from '@di/angularProviderMapper';

@Component({
  selector: 'app-redirect-to-external-bank-error',
  templateUrl: './redirect-to-external-bank-error.component.html',
  styleUrls: ['../../../../shared/css/oney-bottom-skew-container.scss'],
})
export class RedirectToExternalBankErrorComponent implements OnInit {
  constructor(
    private tracker: TrackerService,
    @Inject(browserBroadcastToken) private broadcastService: BrowserBroadcast
  ) {}

  ngOnInit(): void {
    this.tracker.trackPage({ taggingPage: 'REDIRECT_TO_EXTERNAL_BANK_ERROR' });

    this.broadcastService.publish({
      label: 'REDIRECT_TO_EXTERNAL_BANK_LOGIN_ERROR',
      data: null,
    });
  }

  closeTab() {
    this.tracker.trackClick({
      taggingPage: 'REDIRECT_TO_EXTERNAL_BANK_ERROR',
      click: frenchi18n.common_closeTab,
    });

    window.close();
  }
}
